(function () {
  const form = document.querySelector("#delivery-search");
  const input = document.querySelector("#postal-code");

  function normalizePostalCode(value) {
    return value
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, "");
  }

  function getFsa(value) {
    return normalizePostalCode(value).slice(0, 3);
  }

  function isAllowedPostalCode(region, normalized) {
    if (!region.allowedPostalCodes) return true;
    return region.allowedPostalCodes.includes(normalized);
  }

  function isExcludedPostalCode(region, normalized) {
    if (!region.excludedPostalCodePrefixes || normalized.length <= 3) return false;
    return region.excludedPostalCodePrefixes.some((prefix) => normalized.startsWith(prefix));
  }

  form.addEventListener("submit", function (event) {
    event.preventDefault();

    const normalized = normalizePostalCode(input.value);
    const fsa = getFsa(input.value);

    if (fsa.length !== 3) {
      window.DeliveryUI.setNotFound(input.value || "blank search");
      return;
    }

    const region = window.DeliveryMap.getRegion(fsa);
    if (region && isExcludedPostalCode(region, normalized)) {
      window.DeliveryUI.setNotFound(normalized || input.value);
      return;
    }

    if (region && !isAllowedPostalCode(region, normalized)) {
      window.DeliveryUI.setNotFound(normalized || input.value);
      return;
    }

    const found = window.DeliveryMap.selectRegion(fsa, {
      fullPostalCode: normalized.length === 6,
      matchedCode: normalized.length > 3 ? normalized : fsa
    });

    if (!found) {
      window.DeliveryUI.setNotFound(normalized || input.value);
    }
  });
})();
